import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import seo from '../seoRoutes.json';

function upsert(selector, tag, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(tag);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
}

// Unknown paths (the "*" → Home fallback) get noindex; nginx answers them with a 404 status too.
export function useRouteSeo() {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname.length > 1 ? pathname.replace(/\/$/, '') : pathname;
    const route = seo.routes[path];
    const { title, description } = route || seo.routes['/'];
    const url = window.location.origin + (route ? path : '/');
    document.title = title;
    upsert('meta[name="description"]', 'meta', { name: 'description', content: description });
    upsert('meta[name="robots"]', 'meta', {
      name: 'robots',
      content: !route || route.noindex ? 'noindex, nofollow' : 'index, follow',
    });
    upsert('link[rel="canonical"]', 'link', { rel: 'canonical', href: url });
    upsert('meta[property="og:title"]', 'meta', { property: 'og:title', content: title });
    upsert('meta[property="og:description"]', 'meta', { property: 'og:description', content: description });
    upsert('meta[property="og:url"]', 'meta', { property: 'og:url', content: url });
  }, [pathname]);
}
